exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collection-card {\n  display: grid;\n  grid-template-columns: 4fr 1fr;\n  width: 100%;\n}\n.collection-card-panel {\n  display: grid;\n  grid-template-columns: 2fr 5fr;\n}\n.collection-card-panel__photo {\n  display: flex;\n  flex-grow: 1;\n  height: 100%;\n}\n.collection-card-panel__info {\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  justify-content: space-around;\n  flex-grow: 2;\n}\n.collection-card-panel__info__name {\n  font-size: 18px;\n  font-weight: 400;\n  color: #000000;\n}\n.collection-card-panel__info__vendor {\n  font-size: 16px;\n  font-weight: 400;\n}\n.collection-card-panel__info__vendor > span:first-child {\n  color: #a7a8aa;\n}\n.collection-card-edit {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 16px;\n  flex-grow: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Collections/components/CollectionCard/CollectionCard.less
// module id = 1228
// module chunks = 0